import dayjs from 'dayjs'
import { formatUSDCurrency, strSlug } from '~/helpers/format'

export default {
  methods: {
    strSlug (str) {
      return strSlug(str)
    }
  },
  filters: {
    creditCardNumber (value) {
      return value?.replace(/\W/gi, '').replace(/(.{4})/g, '$1 ').trim()
    },
    USDCurrencyFormat (value) {
      return formatUSDCurrency(value)
    },
    USDateFormat (value) {
      if (value && value !== '0000-00-00 00:00:00') {
        return dayjs(value).format('MM/DD/YYYY')
      }
    }
  }
}
